import { createApp } from 'vue'
import rswt from './rswt.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

const app = createApp(rswt);
app.mount("#app");
